/* MCCGA (2026-07-07, Tiffany): tag collection-grid quick-add buttons that
   PreProduct has relabeled to "Pre-order" so CSS can make ONLY those pop.
   PreProduct stamps data-quick-pre-order on every quick-add button, so the
   rendered label text is the only reliable discriminator. */
(() => {
	const RE = /pre-?order/i;
	let scheduled = false;

	const mark = () => {
		scheduled = false;
		document.querySelectorAll(".quick-add__submit").forEach((btn) => {
			btn.classList.toggle("mccga-preorder-btn", RE.test(btn.textContent));
		});
	};

	const schedule = () => {
		if (!scheduled) {
			scheduled = true;
			requestAnimationFrame(mark);
		}
	};

	// PreProduct relabels after load (and on quick-add modal renders) — observe
	// childList/characterData only, so our own classList writes can't loop.
	new MutationObserver(schedule).observe(document.body, {
		subtree: true,
		childList: true,
		characterData: true,
	});

	if (document.readyState === "loading") {
		document.addEventListener("DOMContentLoaded", schedule);
	} else {
		schedule();
	}
})();
